import React from "react"
import { Progress } from 'antd';

interface Props {
  percentage: number,
  progress: number,
  max: number,
  status: string,
  showInfo: boolean,
  showPercentage: boolean
}

export class ProgressBar extends React.Component<Props, {}> {
  static defaultProps = {
    status: "normal",
    showInfo: true,
    showPercentage: true
  }


  render(): JSX.Element {
    return (
      <>
        <Progress
          showInfo={this.props.showInfo}
          strokeColor={getColor(this.props.status).color}
          percent={Number(this.props.percentage.toFixed())}
          size="small"
          status={this.props.showPercentage ? "normal" : undefined}
        />
        <span>{this.props.progress} / {this.props.max}</span>
      </>
    )
  }
}


const getColor = (status: string): { type: string, color: string } => {
  switch (status) {
    case 'ON_GOING': return { type: "on-going", color: "#f59e0c" }
    case 'PENDING': return { type: 'waiting', color: "#ef4444" }
    case 'COMPLETE': return { type: 'completed', color: "#10b981" }
    case 'TO_DO': return { type: 'to-do', color: "black" }
    default: return { type: 'waiting', color: "#ef4444" }
  }
}

const getStatus = (status: string): string => {
  switch (status) {
    case 'ON_GOING': return "En cours"
    case 'PENDING': return 'En attente'
    case 'COMPLETE': return 'Terminé'
    case 'TO_DO': return 'A faire'
    default: return 'En attente'
  }
}

export const Status = (props: { status: string }) => (
  <>
    <div className={getColor(props.status).type + "-dot"} />
    <span className={getColor(props.status).type}>{getStatus(props.status)}</span>
  </>
)